module.exports = __webpack_public_path__ + "static/woman-reading-tax-documents-desktop.8928f73c.webp";